import * as React from 'react';

import { Table, ITableOptions, ITableColumn } from '../../../../_common/platform/tsx/tableSelect/Table';
export { ITableOptions } from '../../../../_common/platform/tsx/tableSelect/Table';

const tableColumns: ITableColumn[] = [
    {
        className: 'column-select',
        title: ''
    },
    {
        className: 'column-name',
        title: 'Name',
        sort: true
    }
];

export function TableSelect2cols(props: { options: ITableOptions }) {
    return (
        <div className={'table-select-static table-select-list'}>
            <Table columns={tableColumns} options={props.options} />
        </div>
    );
}
